export type TokenFrameStyle = "CLASSIC"
    | "ORNATE"
    | "OUROBOROS"
    | "ORANGE"
    | "PURPLE"
    | "CELTIC"
    | "RAVEN_FEATHERS"
    | "RAVENLOFT"
    | "THORN_WREATH"
    | "GRAVESTONE";

export const DEFAULT_TOKEN_FRAME_STYLE: TokenFrameStyle = "CLASSIC";
